import { FormatMessageOptions } from '@eo-locale/core'
import { ZodIssue } from 'zod'

export type HasError = {
  rating: { hasError: boolean; msg: string }
  author: { hasError: boolean; msg: string }
  content: { hasError: boolean; msg: string }
}

export const translateZodError = (
  error: string | boolean | ZodIssue[] | null,
  translate: (key: string, options?: FormatMessageOptions) => string
): HasError => {
  if (Array.isArray(error)) {
    const errorContent = new Set<{ path: string; msg: string }>(
      error
        .map(err => {
          if (typeof err.path[0] === 'string') {
            return { path: err.path[0], msg: err.message }
          } else {
            return null
          }
        })
        .filter((err): err is { path: string; msg: string } => err !== null)
    )
    const newHasError: HasError = ['rating', 'author', 'content'].reduce<HasError>(
      (acc, key) => {
        const error = Array.from(errorContent).find(err => err.path === key)
        Array.from(errorContent).map(err => {
          if (err.msg === 'Rating must be at least 1') {
            err.msg = translate('Product_Review_Error_Rating_Empty')
          } else if (err.msg === 'Name or alias must be included, or choose to be anonymous') {
            err.msg = translate('Product_Review_Error_Name_Empty')
          } else if (err.msg === 'First name is too long') {
            err.msg === translate('Product_Review_Error_Name_Too_Long')
          } else if (err.msg === 'Name can only contain letters and spaces') {
            err.msg = translate('Product_Review_Error_Name_Format')
          } else if (err.msg === 'You need to write a review') {
            err.msg = translate('Product_Review_Error_Content_Empty')
          } else if (err.msg === 'Remove all "<" or ">" from the text.') {
            err.msg = translate('Product_Review_Error_Content_Format')
          }
        })
        acc[key as keyof HasError] = { hasError: !!error, msg: error ? error.msg : '' }
        return acc
      },
      {
        rating: { hasError: false, msg: '' },
        author: { hasError: false, msg: '' },
        content: { hasError: false, msg: '' },
      }
    )
    return newHasError
  } else {
    return {
      rating: { hasError: false, msg: '' },
      author: { hasError: false, msg: '' },
      content: { hasError: false, msg: '' },
    }
  }
}
